import { IApplicationState } from '../../types/redux';
import { ITag } from '../../types/tag';

export function getActiveTagFilters(state: IApplicationState): ITag | undefined {
  return state.filters.tags.find(el => el.isSelected);
}
